<div class="grid-row">
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
        <legend class="usa-legend usa-legend--medium">Edit TSP Rates</legend>
    </div>
</div>
<form id="frtViewRatesFormGroup" role="form" [formGroup]="frtViewRatesFormGroup" (ngSubmit)="search()">
    <div class="grid-row grid-gap-1">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
            <label class="usa-label" for="rate_type">Rate Type</label>
            <select id="rate_type" class="maxw-full usa-select" formControlName="rateType" (change)="onRateTypeChange()">
        <option value='' selected disabled>Choose...</option>
        <option [value] = '18'>Freight - TL</option>
        <option [value] = '19'>Freight - LTL</option>
        <option [value] = '20'>Fleet Vehicles - Domestic 1</option>
        <option [value] = '21'>Fleet Vehicles - Domestic 2</option>
        <option [value] = '22'>Fleet Vehicles - Domestic 3</option>
        <option [value] = '23'>Fleet Vehicles - International 1</option>
        <option [value] = '24'>Fleet Vehicles - International 2</option>
        <option [value] = '25'>Fleet Vehicles - International 3</option>
      </select>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
            <label class="usa-label" for="agency_id">SRO ID</label>
            <select id="agency_id" class="maxw-full usa-select" formControlName="sroId" (change)="onSroChange($event.target.value)">
        <option value='' selected disabled>Choose...</option>
        <option *ngFor="let sro of sroIdList" [value]="sro.sroMasterId">{{sro.sroId}}
        </option>
      </select>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
            <label class="usa-label" for="status">Status</label>
            <select id="status" class="maxw-full usa-select" formControlName="status" (change)="onStatusChange($event.target.value)">
        <option value='' selected disabled>Choose...</option>
        <option *ngFor="let status of statusList" [value]="status[0]">{{status}}</option>
      </select>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
            <label class="usa-label" for="origin">Origin</label>
            <select id="origin" class="maxw-full usa-select" formControlName="origin" (change)="onOriginChange($event.target.value)">
        <option value='' selected disabled>Choose...</option>
        <option *ngFor="let origin of originList" [value]="origin.stateCountryId">
          {{origin.stateCountryName}}
        </option>
      </select>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
            <label class="usa-label" for="destination">Destination</label>
            <select id="destination" class="maxw-full usa-select" formControlName="destination" (change)="onDestinationChange($event.target.value)">
        <option value='0' selected disabled>Choose...</option>
        <option *ngFor="let dest of destinationList" [value]="dest.stateCountryId">
          {{dest.stateCountryName}}
        </option>
      </select>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12" *ngIf="this.frtViewRatesFormGroup.get('rateTableControls').value.length > 0">
            <label class="usa-label">
        Showing page {{currentPage}}  of {{totalPages}}, Total no of  Records: {{totalItems}}
      </label>
        </div>
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
      </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12" *ngIf="showTable">
            <div class="usa-table-container--scrollable" tabindex="0">
                <table class="usa-table">
                    <thead>
                        <tr>
                            <th *ngFor="let header of headerElements" scope="col">{{header}}</th>
                        </tr>
                    </thead>
                    <tbody formArrayName="rateTableControls" *ngFor="let control of this.frtViewRatesFormGroup.get('rateTableControls').controls;
          let i = index">
                        <tr [formGroupName]="i">
                            <td class="text-center">
                                <input type="checkbox" (change)="onSelectDelete($event.target.checked,control.get('ProcureId').value)">
                            </td>
                            <td><input type="text" class="usa-input" formControlName="Status" readonly></td>
                            <td><input type="text" class="usa-input" formControlName="Date" readonly></td>
                            <td><input type="text" class="usa-input" formControlName="Origin" readonly></td>
                            <td><input type="text" class="usa-input" formControlName="Destination" readonly></td>
                            <td><input type="text" class="usa-input" maxlength="4" formControlName="TenderId" (change)="onSelectEditTenderId($event.target.value,control.get('ProcureId').value)">
                                <span class="text-secondary" *ngIf="control.get('TenderId').touched && control.get('TenderId').hasError('required')">
                <br>Tender Id is required!</span>
                                <span class="text-secondary" *ngIf="control.get('TenderId').touched && control.get('TenderId').hasError('maxlength')">
                <br>Tender Id cannot exceed 4 characters!</span>
                                <span class="text-secondary" *ngIf="control.get('TenderId').touched && control.get('TenderId').hasError('maxlength')">
                <br>Tender Id must be 4 characters!</span>
                              <span class="text-secondary" *ngIf="control.get('TenderId').touched && control.get('TenderId').hasError('pattern')">
                <br>Tender Id has invalid characters</span>
                            </td>

                            <td *ngIf="!rate18">
                      <input type="text" class="usa-input"
                      formControlName="ltlSurCharge" maxlength="6" appTwoDigitDecimalNumber
                      (change) = "onSelectEditLtlSurCharge($event.target.value,control.get('ProcureId').value)">
                      <span class="text-secondary"
                        *ngIf="control.get('ltlSurCharge').touched && control.get('ltlSurCharge').hasError('pattern')">
                        <br>LTL Surcharge should have numbers only!</span>
                      <span class="text-secondary"
                       *ngIf="control.get('ltlSurCharge').touched && control.get('ltlSurCharge').hasError('ltlSur1')">
                       <br>LTL Surcharge Percent is greater than the LTL Maximum Percent allowed for this Rate Cycle!</span>
                      <span class="text-secondary"
                       *ngIf="control.get('ltlSurCharge').touched && control.get('ltlSurCharge').hasError('ltlSur2')">
                       <br>LTL Surcharge Amount is 0.00 but Minimum Charge is not 0.00!</span>
                    </td>

                    <td *ngIf="!rate18"><input type="text" class="usa-input"
                      formControlName="ltlSurChgLimit" readonly>
                    </td>

                    <td *ngIf="!rate18">
                      <input type="text" class="usa-input" maxlength="6"
                      formControlName="ltlMinCharge" appTwoDigitDecimalNumber
                      (change) = "onSelectEditLtlMinCharge($event.target.value,control.get('ProcureId').value)">
                      <span class="text-secondary"
                        *ngIf="control.get('ltlMinCharge').touched && control.get('ltlMinCharge').hasError('pattern')">
                        <br>LTL Minimum charge should have numbers only!</span>
                      <span class="text-secondary"
                       *ngIf="control.get('ltlMinCharge').touched && control.get('ltlMinCharge').hasError('ltlMin1')">
                       <br>LTL Minimum Charge Percent is greater than the LTL Minimum Percent allowed for this Rate Cycle!</span>
                    </td>

                    <td *ngIf="!rate18"><input type="text" class="usa-input"
                      formControlName="ltlMinChgLimit" readonly>
                    </td>

                    <td *ngIf="rate18">
                      <input type="text" class="usa-input" maxlength="10"
                      formControlName="tlRateAmt" appTwoDigitDecimalNumber
                      (change) = "onSelectEditTlRateAmt($event.target.value,control.get('ProcureId').value)" >
                      <span class="text-secondary"
                        *ngIf="control.get('tlRateAmt').touched && control.get('tlRateAmt').hasError('pattern')">
                        <br>Rate Amount should have numbers only!</span>
                      <span class="text-secondary"
                      *ngIf="control.get('tlRateAmt').touched && control.get('tlRateAmt').hasError('tlSur1')">
                      <br>TL Rate Amount is greater than the TL Maximum Rate Amount allowed for this Rate Cycle!</span>
                     <span class="text-secondary"
                      *ngIf="control.get('tlRateAmt').touched && control.get('tlRateAmt').hasError('tlSur2')">
                      <br>TL Rate Amount is 0.00 but Minimum Charge is not 0.00!</span>
                    </td>

                    <td *ngIf="rate18"><input type="text" class="usa-input"
                      formControlName="tlRateAmtLimit" readonly>
                    </td>

                    <td *ngIf="rate18">
                      <input type="text" class="usa-input"
                      formControlName="tlMinCharge" maxlength="10" appTwoDigitDecimalNumber
                      (change) = "onSelectEditTlMinCharge($event.target.value,control.get('ProcureId').value)" >
                      <span class="text-secondary"
                        *ngIf="control.get('tlMinCharge').touched && control.get('tlMinCharge').hasError('pattern')">
                        <br>Minimum Charge should have numbers only!</span>
                      <span class="text-secondary"
                      *ngIf="control.get('tlMinCharge').touched && control.get('tlMinCharge').hasError('tlMin1')">
                      <br>TL Minimum Charge is greater than the TL Maximum Charge allowed for this Rate Cycle!</span>
                    </td>

                    <td *ngIf="rate18"><input type="text" class="usa-input"
                      formControlName="tlMinChgLimit" readonly>
                    </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</form>
<div class="grid-row">
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
        <app-pagination *ngIf="this.frtViewRatesFormGroup.get('rateTableControls').value.length > 0" [totalItems]="totalItems" [itemsPerPage]="itemsPerPage" (itemsPerPageChange)="itemsPerPageChanged($event)" [currentPage]="currentPage" (currentPageChange)="page($event)">
        </app-pagination>
    </div>
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12" *ngIf="this.frtViewRatesFormGroup.get('rateTableControls').value.length > 0">
        <ul class="usa-button-group">
            <li class="usa-button-group__item">
                <button type="button" class="usa-button" (click)="edit()">{{editButtonText}}</button>
            </li>
            <li class="usa-button-group__item">
                <button type="button" class="usa-button" (click)="openAccessorials()">Accessorials</button>
            </li>
        </ul>
    </div>
</div>
